/* unplugin-vue-components disabled */import script from "./ContractManager.vue?vue&type=script&setup=true&lang=js"
export * from "./ContractManager.vue?vue&type=script&setup=true&lang=js"

import "./ContractManager.vue?vue&type=style&index=0&id=2bcf0a12&lang=scss"

const __exports__ = script;

export default __exports__